import styled from 'styled-components';
import { colors } from '../../../../../assets/colors';

export const Container = styled.div`
	width: 100%;
	padding: 0.9375rem;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	align-content: flex-end;

	color: ${colors.lightGray};
	border-radius: 15px;
`;

export const Row = styled.div`
	display: flex;
	justify-content: center;
	align-content: flex-end;
`;

export const Column = styled.div`
	padding-right: 0.75rem;
	display: flex;
	flex-direction: column;
	align-content: flex-end;
`;

export const ColumnTitle = styled.div`
	text-align: left;
	color: ${colors.lightestGray};
	font-size: 1rem;
	font-weight: 600;
	letter-spacing: 0.005em;
	width: 10.4375rem;
	margin-bottom: 1.25rem;
`;
